import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { constants } from '../shared/constants/constants';
import { BaseService } from './base-service';
import { Url } from '../lib/Url';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root',
})
export class PowerCheckerService extends BaseService {
    private timerSub: Subscription = null;

    constructor(
        protected http: HttpClient,
        protected auth: ApiService,
        protected user: UserService
    ) {
        super(http, auth, user);
    }

    destroy(): void {
        super.destroy();
        if (this.timerSub) {
            this.timerSub.unsubscribe();
            delete this.timerSub;
        }
    }

    /**
     * Returns whether the user participates in the HappyHour.
     */
    getState(): Observable<any> {
        const url = new Url(null);
        url.push(this.API_BASE_URL);
        url.push(constants.api.routes.plug.relay);

        return this.http.get(url.toString()).pipe(
            map((res: { status: string; data: any }) => this.mapDefault(res)),
            catchError((e) => {
                console.log('Error:', e);
                return throwError(e);
            })
        );
    }

    setState(value): Observable<any> {
        const url = new Url(null);
        url.push(this.API_BASE_URL);
        url.push(constants.api.routes.plug.relay);
        const payload = { on_off: value };
        return this.http.put(url.toString(), payload).pipe(
            map((res: { status: string; data: any }) => this.mapDefault(res)),
            catchError((e) => {
                console.log('Error:', e);
                return throwError(e);
            })
        );
    }
}
